import React, { useState, useEffect } from 'react';

import { animated, useSpring, useInView } from '@react-spring/web'

import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import FloatingActionButton from './FloatingActionButton';
import AgentLeaderboardEntry from './AgentLeaderboardEntry';

// import JuliethRomero from '../assets/img/agent-images/Julieth-Romero.png';
// import LisaReyes from '../assets/img/agent-images/Lisa-Reyes.png';
// import ChristineGioia from '../assets/img/agent-images/Christine-Gioia.png';
// import GregScala from '../assets/img/agent-images/Greg-Scala.png';
// import TaylorSchalk from '../assets/img/agent-images/Taylor-Schalk.png';
// import KevinBartlett from '../assets/img/agent-images/Kevin-Bartlett.png';
// import TaniaBobe from '../assets/img/agent-images/Tania-Bobe.png';
// import DebbSummers from '../assets/img/agent-images/Debb-Summers.png';
// import LindsayCalhoun from '../assets/img/agent-images/Lindsay-Calhoun.png';
// import Placeholder from '../assets/img/agent-images/placeholder.jpg';

import { PropsFromRedux } from '../containers/AgentLeaderboardContainer';

import { AppConfig } from '../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
    },
    inner: {
      width: 1000,
    },
    headingText: {
      zIndex: 2,
      position: 'relative',
      textAlign: 'center',
      marginBottom: theme.spacing(4)
    },
    headingTitle: {
      marginBottom: theme.spacing(1),
    },
    headingSubtitle: {

    },
    showMoreButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    showMoreButton: {
      marginTop: 16,
    }
  }),
);

interface IAgentLeaderboard {
  initialDelay?: number
  hideHeading?: boolean
}

// interface ILeaderboardDataRecord {
//   rank: string
//   name: string
//   description: string
//   amount: number | string
//   profile_link: string | false
//   image_link?: string
// }

// const leaderboardData: ILeaderboardDataRecord[] = [
//   {
//     rank: '1',
//     name: 'Julieth Romero',
//     description: 'La Rosa Realty Kissimmee',
//     amount: '1660',
//     profile_link: 'https://propy.com/4076391095',
//     image_link: JuliethRomero
//   },
//   {
//     rank: '2',
//     name: 'Lisa Reyes',
//     description: 'eXp Realty',
//     amount: '1120',
//     profile_link: 'https://propy.com/9257855413',
//     image_link: LisaReyes
//   },
//   {
//     rank: '3',
//     name: 'Christine Gioia',
//     description: 'Compass',
//     amount: '1000',
//     profile_link: false,
//     image_link: ChristineGioia
//   },
//   {
//     rank: '4',
//     name: 'Christopher Garren',
//     description: '',
//     amount: '1000',
//     profile_link: false,
//     image_link: Placeholder
//   },
//   {
//     rank: '5',
//     name: 'Greg Scala',
//     description: 'KP Elite',
//     amount: '1000',
//     profile_link: false,
//     image_link: GregScala
//   },
//   {
//     rank: '6',
//     name: 'Taylor Schalk',
//     description: 'The Laughton Team',
//     amount: '1000',
//     profile_link: 'https://propy.com/4802028175',
//     image_link: TaylorSchalk
//   },
//   {
//     rank: '7',
//     name: 'Kevin Bartlett',
//     description: 'Knowledge Base Real Estate',
//     amount: '600',
//     profile_link: false,
//     image_link: KevinBartlett
//   },
//   {
//     rank: '8',
//     name: 'Tania Bobe',
//     description: 'LPT Realty',
//     amount: '470',
//     profile_link: 'https://propy.com/8632702138',
//     image_link: TaniaBobe
//   },
//   {
//     rank: '9',
//     name: 'Debb Summers',
//     description: 'The Pipal Group',
//     amount: '460',
//     profile_link: 'https://propy.com/9374171660',
//     image_link: DebbSummers
//   },
//   {
//     rank: '10',
//     name: 'Lindsay Calhoun',
//     description: 'The American Dream',
//     amount: '390',
//     profile_link: 'https://propy.com/8508389880',
//     image_link: LindsayCalhoun
//   }
// ]

let topThreeColors : {[key: number]: string} = {
  0: "#e7c200",
  1: "#757575",
  2: "#b55200",
}

interface IAutomatedLeaderboardEntry {
  id: string,
  name: string,
  organisation: string,
  avatar: string,
  pro: string,
  state: string,
}

const AgentLeaderboard = (props: IAgentLeaderboard & PropsFromRedux) => {
    const classes = useStyles();

    const [showFullLeaderboard, setShowFullLeaderboard] = useState(false);
    const [automatedLeaderboardData, setAutomatedLeaderboardData] = useState<IAutomatedLeaderboardEntry[]>([]);

    const {
      initialDelay = 0,
      hideHeading = false,
    } = props;

    const [ref, isInView] = useInView({
      amount: 'any',
      once: true,
    })

    const titleSpring = useSpring({
      from: {
        opacity: 0,
        top: -25,
      },
      to: {
        opacity: isInView ? 1 : 0,
        top: isInView ? 0 : -25,
      },
      delay: initialDelay
    })

    const showMoreButtonSpring = useSpring({
      from: {
        opacity: 0,
        marginTop: '-35px',
      },
      to: {
        opacity: isInView ? 1 : 0,
        marginTop: isInView ? '0' : '-35px',
      },
      delay: initialDelay + (200 * 4),
    })

    useEffect(() => {
      fetch(`${AppConfig.API_BASE_URL}/Reports/users/top`).then((response) => response.json()).then((data) => {
        setAutomatedLeaderboardData(data);
      })
    }, [])

    return (
      <div className={classes.root} ref={ref}>
        <div className={classes.inner}>
          {!hideHeading &&
            <animated.div className={classes.headingText} style={titleSpring}>
              <Typography className={classes.headingTitle} style={{fontWeight: 'bold'}} variant="h3">
                Agent Leaderboard
              </Typography>
              <Typography className={classes.headingSubtitle} variant="h5" component="h4">
                Featuring this month's top performing agents on the Propy platform
              </Typography>
            </animated.div>
          }
          {/* <Grid style={{justifyContent: 'center'}} container columns={12} spacing={2}>
              {leaderboardData.map((leaderboardEntry, index) => 
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <AgentLeaderboardEntry
                    activateAnimation={isInView}
                    position={index + 1}
                    name={leaderboardEntry.name}
                    description={leaderboardEntry.description}
                    amount={leaderboardEntry.amount}
                    imageLink={leaderboardEntry.image_link}
                    profileLink={leaderboardEntry.profile_link}
                    baseDelay={initialDelay}
                    animationDelayMultiplier={index + 1}
                    positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                  />
                </Grid>
              )}
          </Grid> */}
          <Grid style={{justifyContent: 'center'}} container columns={12} spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              {/* {leaderboardData.map((leaderboardEntry, index) => 
                index < 3 &&
                <div style={index > 0 ? {marginTop: 16} : {}}>
                  <AgentLeaderboardEntry
                    activateAnimation={isInView}
                    position={index + 1}
                    name={leaderboardEntry.name}
                    description={leaderboardEntry.description}
                    amount={leaderboardEntry.amount}
                    imageLink={leaderboardEntry.image_link}
                    profileLink={leaderboardEntry.profile_link}
                    baseDelay={initialDelay}
                    animationDelayMultiplier={index + 1}
                    positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                    // borderColor={topThreeColors[index] ? topThreeColors[index] : undefined}
                  />
                </div>
              )} */}
              {automatedLeaderboardData.map((leaderboardEntry, index) => 
                index < 3 &&
                <div style={index > 0 ? {marginTop: 16} : {}}>
                  <AgentLeaderboardEntry
                    activateAnimation={isInView}
                    position={index + 1}
                    name={leaderboardEntry.name}
                    description={leaderboardEntry.organisation}
                    amount={leaderboardEntry.pro}
                    imageLink={leaderboardEntry.avatar}
                    state={leaderboardEntry.state}
                    profileLink={`${AppConfig.BASE_URL}/agent/${leaderboardEntry.id}`}
                    baseDelay={initialDelay}
                    animationDelayMultiplier={index + 1}
                    positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                    // borderColor={topThreeColors[index] ? topThreeColors[index] : undefined}
                  />
                </div>
              )}
              <>
                <>
                  {!showFullLeaderboard &&
                    <animated.div style={showMoreButtonSpring} className={classes.showMoreButtonContainer}>
                      <FloatingActionButton
                        className={classes.showMoreButton}
                        onClick={() => {setShowFullLeaderboard(true)}}
                        text="Show Full Leaderboard"
                        buttonColor="secondary"
                      />
                    </animated.div>
                  }
                </>
                {/* {showFullLeaderboard && leaderboardData.map((leaderboardEntry, index) => 
                  index >= 3 &&
                  <div style={index >= 3 ? {marginTop: 16} : {}}>
                    <AgentLeaderboardEntry
                      activateAnimation={true}
                      position={index + 1}
                      name={leaderboardEntry.name}
                      description={leaderboardEntry.description}
                      amount={leaderboardEntry.amount}
                      imageLink={leaderboardEntry.image_link}
                      profileLink={leaderboardEntry.profile_link}
                      baseDelay={0}
                      animationDelayMultiplier={index}
                      positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                      scaleFactor={0.6}
                    />
                  </div>
                )} */}
                {showFullLeaderboard && automatedLeaderboardData.map((leaderboardEntry, index) => 
                  index >= 3 &&
                  <div style={index >= 3 ? {marginTop: 16} : {}}>
                    <AgentLeaderboardEntry
                      activateAnimation={true}
                      position={index + 1}
                      name={leaderboardEntry.name}
                      description={leaderboardEntry.organisation}
                      amount={leaderboardEntry.pro}
                      imageLink={leaderboardEntry.avatar}
                      state={leaderboardEntry.state}
                      profileLink={`${AppConfig.BASE_URL}/agent/${leaderboardEntry.id}`}
                      baseDelay={0}
                      animationDelayMultiplier={index}
                      positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                      scaleFactor={0.6}
                    />
                  </div>
                )}
              </>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={6} lg={6}>
              {leaderboardData.map((leaderboardEntry, index) => 
                index >= 3 &&
                <div style={index > 3 ? {marginTop: 16} : {}}>
                  <AgentLeaderboardEntry
                    activateAnimation={isInView}
                    position={index + 1}
                    name={leaderboardEntry.name}
                    description={leaderboardEntry.description}
                    amount={leaderboardEntry.amount}
                    imageLink={leaderboardEntry.image_link}
                    profileLink={leaderboardEntry.profile_link}
                    baseDelay={initialDelay}
                    animationDelayMultiplier={index + 1}
                    positionCircleColorOverride={topThreeColors[index] ? topThreeColors[index] : undefined}
                    scaleFactor={0.6}
                  />
                </div>
              )}
            </Grid> */}
          </Grid>
        </div>
      </div>
    )
};

export default AgentLeaderboard;